export class PeerToPeerMessenger {
  listeners = [];
  constructor({ messenger }) {
    this.messenger = messenger;
  }

  on(jid, message, callback) {
    const onMessage = (state, from) => {
      if (jid === from) callback(state, from);
    };

    this.listeners.push({ jid, callback, message, onMessage });

    this.messenger.on(message, onMessage);
  }

  off(jid, message, callback) {
    this.removeListener(jid, message, callback);
  }

  removeListener(jid, message, callback) {
    let index;
    this.listeners.forEach((listener, i) => {
      if (
        listener.jid === jid &&
        listener.message === message &&
        listener.callback === callback
      ) {
        index = i;
        this.messenger.removeListener(listener.message, listener.onMessage);
      }
    });
    this.listeners = this.listeners.filter((listener, i) => i !== index);
  }
}
